'use client';
import type { FC } from 'react';
import { Button } from '~/app/_components/button';
import { css } from '@styled-system/css';
import { Paragraph } from '@styled-system/jsx';
import meritCheck from './assets/merit-check.svg';
import storyReadBecomeVip from './assets/story-read-become-vip.svg';

type Props = {
  onClickBecomeVip?: () => void;
};

export const PaywallPcContent: FC<Props> = ({ onClickBecomeVip }) => {
  return (
    <>
      <Paragraph fontSize="size_18" fontWeight="700" mb="8px">
        続きはVIPプランで読みましょう
      </Paragraph>
      <img
        src={storyReadBecomeVip}
        width="161"
        height="30"
        alt="今なら7日間無料"
        className={css({ margin: 'auto', display: 'block' })}
      />
      <ul
        className={css({
          whiteSpace: 'nowrap',
          minWidth: '284px',
          margin: '24px auto',
          '& li': {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '12px',
            _lastOfType: { marginBottom: 0 },
            '& img': {
              height: '18px',
              width: '18px',
              marginRight: '12px',
            },
          },
        })}
      >
        <li>
          <img src={meritCheck} alt="メリット" />
          <Paragraph fontWeight="bold">
            10,000以上のストーリーが読み放題
          </Paragraph>
        </li>
        <li>
          <img src={meritCheck} alt="メリット" />
          <Paragraph fontWeight="bold">VIP限定ストーリーが読める</Paragraph>
        </li>
        <li>
          <img src={meritCheck} alt="メリット" />
          <Paragraph fontWeight="bold">広告表示なし</Paragraph>
        </li>
      </ul>
      <Button type="pill" onClick={onClickBecomeVip}>
        続きを読む（無料）
      </Button>
      <Paragraph marginTop="8px" fontSize="size_12">
        いつでもキャンセル可能。
      </Paragraph>
    </>
  );
};
